import { Controller } from "stimulus";
import { createPopper } from "@popperjs/core";

export default class extends Controller {
  static targets = ["popup"];

  stateSelected(event) {
    // Find the state element via event delegation
    const stateEl = event.target.closest(".map-selector-region-container");

    if (!stateEl) return;

    const openInNewTab = event.metaKey || event.ctrlKey || event.button === 1;

    this.clearSelection();
    stateEl.classList.add("active");

    const url = `${this.baseUrl}/payers/${stateEl.dataset.region}?popup=true`;

    $.ajax({
      url,
      dataType: "html",
      context: this,
      success: data => {
        const popup = document.createRange().createContextualFragment(data);

        // Check if we should bypass the popup and redirect directly
        const statePopper = popup.querySelector("[data-controller='state-popper']");
        const bypassUrl = statePopper?.dataset?.statePopperBypassUrlValue;

        if (bypassUrl) {
          if (openInNewTab) {
            window.open(bypassUrl, "_blank");
          } else {
            window.location.href = bypassUrl;
          }
          return;
        }

        this.element.appendChild(popup);
        this.popper = createPopper(stateEl, this.popupTarget);
      },
    });
  }

  teardown() {
    this.clearSelection();
  }

  clearSelection() {
    if (this.popper) {
      this.popper.destroy();
    }

    this.popupTargets.forEach(t => this.element.removeChild(t));
    this.element
      .querySelectorAll(".map-selector-region-container.active")
      .forEach(t => t.classList.remove("active"));
  }

  onOutsideClick({ target }) {
    if (!this.isInside(target)) {
      this.clearSelection();
    }
  }

  isInside(target) {
    const inState = target.closest(".map-selector-region-container");
    const inPopup = this.popupTargets.some(p => p.contains(target));

    return inState || inPopup;
  }

  get baseUrl() {
    return this.data.get("base-url");
  }
}
